import { jsxs as t, jsx as C } from "react/jsx-runtime";
function o(r) {
  return /* @__PURE__ */ t("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M19 2H5C4.4473 2 4 2.4478 4 3V21C4 21.5522 4.4473 22 5 22H19C19.5527 22 20 21.5522 20 21V3C20 2.4478 19.5527 2 19 2ZM18 4V16H7.5C6.9612 16 6.4564 16.1326 6 16.3511V4H18ZM6.2249 20C6.085 19.9289 6 19.7865 6 19.5C6 18.6729 6.6729 18 7.5 18H18V20H6.2249Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M9 7.75H15C15.4141 7.75 15.75 7.4141 15.75 7C15.75 6.5859 15.4141 6.25 15 6.25H9C8.5859 6.25 8.25 6.5859 8.25 7C8.25 7.4141 8.5859 7.75 9 7.75Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M9 10.75H15C15.4141 10.75 15.75 10.4141 15.75 10C15.75 9.5859 15.4141 9.25 15 9.25H9C8.5859 9.25 8.25 9.5859 8.25 10C8.25 10.4141 8.5859 10.75 9 10.75Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  o as default
};
